module.exports = __webpack_public_path__ + "static/christmas-thumbnail-0ecc4a34c1ba694899b39545757a5bea.png";